import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { iif, Observable, of } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { switchMap, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { httpConstants } from './http-constants';
import { httpI18nKeys } from './http-i18n-keys';
import { HttpTranslations } from './http-translations';
import { SpinningService } from 'shared/services';

@Injectable({
  providedIn: 'root'
})
export class MmHttpClient {

  constructor(private client: HttpClient,
    private spinningService: SpinningService,
    private messageService: NzMessageService,
    public translations:HttpTranslations,
    private translateService: TranslateService) {
  }

  get<T>(url: string, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
    showSpinning?: boolean;
  }): Observable<T> {

    options = {
      ...{
        showSpinning: true
      },
      ...options
    }
    var get$ = this.client.get<T>(url, options);

    if (options.showSpinning) {
      get$ = this.spinningService.startWith(get$);
    }
    return get$;
  }

  post<T>(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
    showSpinnning?: boolean;
    successMessage?: string | Observable<any>
  }): Observable<T> {
    options = {
      ...{
        showSpinnning: true
      },
      ...options
    }
    var post$ = this.client.post<T>(url, body, options);

    if (options && options.showSpinnning) {
      post$ = this.spinningService.startWith(post$);
    }

    if (options.successMessage) {
      post$ = post$.pipe(
        switchMap(() => iif(
          () => typeof options.successMessage === "string",
          of(options.successMessage),
          (options.successMessage as Observable<any>)
        )),
        tap(message => {
          this.messageService.success(message);
        })
      )

    }
    // if (options.notifyOnSuccess) {
    //   post$ = post$.pipe(
    //     tap(() => {
    //       this._showMessage(options.action)
    //     })
    //   )
    // }

    return post$;

  }

  put<T>(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
    showSpinnning?: boolean;
    successMessage?: string | Observable<any>;
    // notifyOnSuccess?: boolean;
    // action?: "Save" | "Delete";
  }): Observable<T> {

    options = {
      ...{
        showSpinnning: true
      },
      ...options
    }
    var put$ = this.client.put<T>(url, body, options);

    if (options.showSpinnning) {
      put$ = this.spinningService.startWith(put$);
    }

    if (options.successMessage) {
      put$ = put$.pipe(
        switchMap(() => iif(
          () => typeof options.successMessage === "string",
          of(options.successMessage),
          (options.successMessage as Observable<any>)
        )),
        tap(message => {
          this.messageService.success(message);
        })
      )

    }

    // if (options.notifyOnSuccess) {
    //   put$ = put$.pipe(
    //     tap(() => {
    //       this._showMessage(options.action)
    //     })
    //   )
    // }

    return put$;
  }

  delete(url: string, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: "body";
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType: "arraybuffer";
    withCredentials?: boolean,
    showSpinning?: boolean;
    notifyOnSuccess?: boolean;
    successMessage?: string | Observable<any>
  }) {

    options = {
      ...{
        showSpinning: true
      },
      ...options,
    }
    var delete$ = this.client.delete(url, options);
    if (options.showSpinning) {
      delete$ = this.spinningService.startWith(delete$);

    }

    if (options.successMessage) {
      delete$ = delete$.pipe(
        switchMap(() => iif(
          () => typeof options.successMessage === "string",
          of(options.successMessage),
          (options.successMessage as Observable<any>)
        )),
        tap(message => {
          this.messageService.success(message);
        })
      )

    }
    return delete$;

  }





  _showMessage(action: "Save" | "Delete") {
    let key: string;
    if (action == "Save") {
      key = httpI18nKeys.SuccessfullySaved;
    }
    else {
      key = httpI18nKeys.SuccessfullyDeleted;
    }
    return this.translateService.get(`${httpConstants.translationGroup}.${key}`).pipe(
      tap(msg => this.messageService.success(msg))
    ).subscribe();
  }





}
